import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { exceptionRoutes, loggedExceptionPath, brandsRoutes } from '@app/shared/guards/exception-routes';

export const defaultCatalogPageAnalytics = { env_template: 'catalog' };

export enum catalogPageType {
  'default' = 0,
  'campaign' = 1,
  'directShipping' = 2,
  'expressDelivery' = 3
}
export function searchPathMatcher(url: UrlSegment[]) {
  const path = url[0].path;

  if (path === 'search' || path === 'search/') {
    return { consumed: url };
  }

  return null;
}

export function externalLinkLoggedMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const exception = [...loggedExceptionPath];

  return exception.includes(url[0]['path']) ? { consumed: url } : null;
}

/**
 * Take an URL in param, we first check if this url match an exception path,
 * if not we test if this is a product page,
 * if not we check the ugly workaround
 * And if none of this condition is true, we guess this is a catalog page
 * Then we return the catalog page url
 *
 * @export
 * @param {UrlSegment[]} url
 * @returns {(UrlMatchResult | null)}
 */
export function CatalogMatcher(url: UrlSegment[]): UrlMatchResult | null {
  /*
    /!\ This is the exception list for catalog
        It should be the same than:
          - the one in server.ts
          - the one in Akamai
   */
  const exception = exceptionRoutes;
  if (
    exception.includes(url[0]['path']) || // pages matching exceptions
    url[url.length - 1]['path'].endsWith('.shtml') // all .shtml pages === product page
  ) {
    return null;
  }

  // Ugly workaround for 2 levels exceptions
  if (
    url.length > 1 &&
    ((url[0]['path'] === 'nouveautes' && url[1]['path'] === 'avant-premiere') ||
      (url[0]['path'] === 'new-items' && url[1]['path'] === 'preview') ||
      (url[0]['path'] === 'neuheiten' && url[1]['path'] === 'vorschau') ||
      (url[0]['path'] === 'novedades' && url[1]['path'] === 'primicia') ||
      (url[0]['path'] === 'novita' && url[1]['path'] === 'avant-premiere'))
  ) {
    return null;
  }

  /**
   * Dirty fix for : /vintage/brands/ etc
   * TODO: Create a guard for exceptions like those and use the failOver on legacy
   */
  if (url.length > 1 && url[0]['path'] === 'vintage' && brandsRoutes.includes(url[1].path)) {
    return null;
  }

  return { consumed: url };
}

export function campaignMatcher(url: UrlSegment[]) {
  return url.length >= 2 && url[0].path === 'c' && /(.+)-[0-9]+$/.test(url[1].path) ? { consumed: url } : null;
}

export function directShippingMatcher(url: UrlSegment[]) {
  const directShippingPath = [
    'direct-shipping',
    'envoi-direct',
    'spedizione-diretta',
    'direktversand',
    'envio-directo'
  ];
  return url.length >= 2 && url[0].path === 'g' && directShippingPath.includes(url[1].path) ? { consumed: url } : null;
}

export function expressDeliveryMatcher(url: UrlSegment[]) {
  const expressDeliveryPath = [
    'express-delivery',
    'livraison-express',
    'consegna-express',
    'expressversand',
    'entrega-express'
  ];
  return url.length >= 2 && url[0].path === 'g' && expressDeliveryPath.includes(url[1].path) ? { consumed: url } : null;
}

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogPageRoutingModule {}
